import React, { useState } from 'react';
import VerificationLog from './VerificationLog';
import ReceivingHistoryLog from './ReceivingHistoryLog';

// The Stats page's logs: every verified order, and every PO receipt. Both are kept
// mounted so each loads once; the PO Receiving tab only shows for an org that has PO
// Receiving (the backend answers the others with a 402, which ReceivingHistoryLog reports).
export default function StatsLogs({ msalInstance }) {
  const [tab, setTab] = useState('verifications');
  // null until the PO receiving history answers
  const [receiving, setReceiving] = useState(null);
  const receivingAvailable = receiving?.available !== false;

  return (
    <>
      <div style={s.tabs} role="tablist">
        <button
          role="tab"
          aria-selected={tab === 'verifications'}
          style={{ ...s.tab, ...(tab === 'verifications' ? s.tabActive : {}) }}
          onClick={() => setTab('verifications')}
        >
          Verifications
        </button>
        {receivingAvailable && (
          <button
            role="tab"
            aria-selected={tab === 'receiving'}
            style={{ ...s.tab, ...(tab === 'receiving' ? s.tabActive : {}) }}
            onClick={() => setTab('receiving')}
          >
            PO Receiving
            {receiving?.count != null ? ` (${receiving.count}${receiving.notInStriven ? `, ${receiving.notInStriven} not in Striven` : ''})` : ''}
          </button>
        )}
      </div>

      <div hidden={tab !== 'verifications'}>
        <VerificationLog msalInstance={msalInstance} />
      </div>
      <div hidden={!receivingAvailable || tab !== 'receiving'}>
        <ReceivingHistoryLog msalInstance={msalInstance} onLoaded={setReceiving} />
      </div>
    </>
  );
}

const s = {
  tabs: { display: 'flex', gap: 6, marginBottom: 14, borderBottom: '1px solid #eee', flexWrap: 'wrap' },
  tab: { padding: '8px 14px', background: 'none', border: 'none', borderBottom: '2px solid transparent', cursor: 'pointer', fontSize: 14, color: '#666', marginBottom: -1 },
  tabActive: { color: '#111', fontWeight: 600, borderBottom: '2px solid rgb(65, 159, 196)' },
};
